import React from 'react';

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface HeadingsProps {
  text?: string;
  type?: HeadingTag;
  classes?: string;
}

const Headings: React.FC<HeadingsProps> = ({
  text = '',
  type = 'h1',
  classes = ''
}) => {
  const CustomTag = type;

  if (Array.isArray(text)) {
    return (
      <CustomTag className={`text__heading ${classes}`}>
        <>
          {text.map((item, index) => React.isValidElement(item)
            ? <React.Fragment key={index}>{item}</React.Fragment>
            : <span
                key={index}
                className={`${type} ${classes}`}
                dangerouslySetInnerHTML={{
                    __html: item.replace(/\n/g, "<br />"),
                }}
              />
          )}
        </>
      </CustomTag>
    )
  }

  const formatTrademarks = (content: string) =>
    typeof content === "string"
      ? content.replace(/(\w+)(\s*)(®|™)/g, '$1$2<sup>$3</sup>')
      : content;

  return (
    <CustomTag
      className={`text__heading ${classes}`}
      dangerouslySetInnerHTML={{ __html: formatTrademarks(text) }}
    />
  );
};

export default Headings;